import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl; // Assuming the apiUrl is defined in config.json.

const getApplication = async (queryString) => {
  try {
    const url = `${apiUrl}/settings/application-settings${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await httpService.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const addApplication = async (value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/settings/application-settings`,
      value
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const editApplication = async (id, value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/settings/application-settings/edit`,
      value
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

const deleteApplication = async (id, value) => {
  try {
    const { data } = await httpService.post(
      `${apiUrl}/settings/application-settings/delete?Id=${id}`,
      value
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};

export { getApplication, addApplication, editApplication, deleteApplication };
